import React from 'react';
import Svg, { Path } from 'react-native-svg';

const CategoryIcon = ({ width = 24, height = 24, color = '#e8eaed' }) => {
  return (
    <Svg width={width} height={height} viewBox="0 -960 960 960" fill="none">
      <Path
        d="m260-520 220-360 220 360H260ZM700-80q-75 0-127.5-52.5T520-260q0-75 52.5-127.5T700-440q75 0 127.5 52.5T880-260q0 75-52.5 127.5T700-80Zm-580-20v-320h320v320H120Zm580-60q42 0 71-29t29-71q0-42-29-71t-71-29q-42 0-71 29t-29 71q0 42 29 71t71 29Zm-500-20h160v-160H200v160Zm202-420h156l-78-126-78 126Zm78 0ZM360-340Zm340 80Z"
        fill={color}
      />
    </Svg>
  );
};

export default CategoryIcon;
